Presentamos una **nueva experiencia de dashboard** completamente rediseñada, junto con mejoras significativas en el **sistema de órdenes de producción** y rescisión de negociaciones en estado aprobado.

## 🚀 Características Principales

### Dashboard Renovado ✨
<Video src="https://assets.elevenestudio.me/changelog-idc/dashboard.mp4" />
- **Saludo dinámico** personalizado según la hora del día
- **Métricas en tiempo real** de negociaciones activas y totales
- **Negociaciones recientes** con información de moneda y estado
- **Clientes recientes** con datos de contacto y fecha de registro

### Mejora de UX en órdenes de producción 🏗️
<Video src="https://assets.elevenestudio.me/changelog-idc/op.mp4" />
- **Formulario reestructurado** con mejor organización
- **Validación mejorada** de campos y datos
- **Interfaz más intuitiva** para la gestión de órdenes

### Rescisión de Negociaciones 📋
<Video src="https://assets.elevenestudio.me/changelog-idc/rescind-negotiation.mp4" />
- **Rescisión extendida** - Ahora se permite rescindir negociaciones en estado aprobado
- **Diálogo de confirmación** para evitar acciones accidentales

## ✨ Implementaciones

- **Módulo de Propiedades** - Se agregaron nuevos campos para datos de construcción y servicios públicos
  - **Datos de Propiedad**
    - Folio
    - Libro
    - IUSI
    - Medidor de agua
    - Medidor de electricidad
    - Teléfono
  - **Datos de Construcción**
    - M2 de terreno
    - M2 de terreno V2
    - M2 de estacionamiento
    - M2 de construcción

## 🔧 Mejoras

- **Filtros de negociaciones en la URL** al recargar la página mantienen su estado
- **Orden de formularios** en clientes
  - Anteriormente:
    - Datos del formulario y personales
    - ...
    - Información económica
    - Estado patrimonial
  - Ahora:
    - Datos del formulario y personales
    - ...
    - Estado patrimonial
    - Información económica

## 🐛 Correcciones

- **Campo invertido - ¿Es compra?** corregido para datos de referidos en formularios de negociación
- Variable **nombre_propietario** en contratos dinamicos rellenado correctamente
- **Logo del proyecto** en contratos dinamicos obtenido correctamente

## 📈 Impacto

Esta versión se enfoca en mejorar significativamente la experiencia del usuario con un dashboard más informativo y funcional, mientras que el sistema de órdenes de producción recibe una reestructuración completa para mayor eficiencia. La nueva funcionalidad de rescisión extendida permite mayor flexibilidad en la gestión de negociaciones, permitiendo rescindir cuando están en estado aprobado, lo que mejora el control y la auditoría de acciones críticas.